/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.base.js" />
(
    function (skyward, $, undefined)
    {
        skyward.transportation = skyward.transportation || {};

        var filterData =
        {
            BusID: null,
            BusRouteID: null,
        };

        var init = function (selector)
        {            
            if ($(selector).find("#SelectedImportFileType").length > 0)
            {
                var element = $(selector).find("#SelectedImportFileType");
                element.on('change', openTransportationFileLayoutPopup);
            }

            // Stop init if not on the student bus stop list.
            if ($(selector).find('.busSelector').length == 0)
            {
                return;
            }

            // Intitialize Bus Selector trigger
            if ($(selector).find('.busSelector').length > 0)
            {
                var element = $(selector).find(".busSelector");
                element.on('change', skyward.transportation.filterBus);
            }

            // Intitialize Route Selector trigger
            if ($(selector).find('.busRouteSelector').length > 0)
            {
                var element = $(selector).find(".busRouteSelector");
                element.on('change', skyward.transportation.filterRoute);
            }
        };

        skyward.transportation.filterBus = function ()
        {
            var busEEL = $(this);            
            filterData.BusID = busEEL.val();
            filterData.BusRouteID = null;
            filterData.PortalCode = busEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        skyward.transportation.filterRoute = function ()
        {
            var routeEEL = $(this);
            filterData.BusRouteID = routeEEL.val();
            filterData.PortalCode = routeEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        var updateContent = function ()
        {
            var action = "List";
            if (filterData.PortalCode == "TeacherAccess")
            {
                action = "TeacherAccessList";
            }
            skyward.window.loadContent("moduleContent", "Transportation", "StudentBusStop", action, null, filterData);
        };

        var openTransportationFileLayoutPopup = function (event)
        {
            var button = $(this);
            var data = button.data();
            var module = data.module;
            var controller = data.object;
            var action = data.action;
            var title = data.title;
            var fieldset = $(this).closest(".js-layoutImportType");
            var importType = skyward.controls.getValue(fieldset.find("#SelectedImportFileType"));
            buildTransportationFileLayoutPanelAjax(module, controller, action, {
                importType: importType,
            }, button);
        };

        var updateTransportationLayoutInformation = function (html, button)
        {
            var fieldset = button.parents(".js-layoutImportType");
            var layoutFieldset = fieldset.siblings(".js-fileLayoutFieldset");
            var container = layoutFieldset.find(".js-fileLayout");
            container.html(html);
        };

        var buildTransportationFileLayoutPanelAjax = function (module, controller, action, data, button)
        {

            $.ajax(
                {
                    url: skyward.global.virtualDir + module + "/" + controller + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        if (returnData.html)
                        {
                            updateTransportationLayoutInformation(returnData.html, button);
                        }
                    }
                });
        };

        var CRQE_ROW_SELECTOR = '.childrecordquickentryrow:not(.removedElement)';
        var COLUMN_NUMBER_SELECTOR = '.comboBoxSet.ColumnNumber';

        var initChildRecordQuickEntry = function ()
        {
            var crqe = $(this);
            crqe.on('childrecordquickentry-row-added', function (event, row)
            {
                setNextColumnNumber(crqe, row);
            });
        };

        var setNextColumnNumber = function (crqe, row)
        {
            var highest = 0;
            crqe.find(COLUMN_NUMBER_SELECTOR).each(function ()
            {
                var columnNumberElement = $(this);
                var value = parseInt(skyward.controls.getValue(columnNumberElement));
                if (value > highest)
                {
                    highest = value;
                }
            });

            highest = parseInt(highest) + 1;
            var specificRowColumnNumberElement = row.find(COLUMN_NUMBER_SELECTOR);
            skyward.controls.setValue(specificRowColumnNumberElement, highest);
        };

        var events =
        {
            "initChildRecordQuickEntry": initChildRecordQuickEntry
        };

        skyward.events.registerEvents("transportation", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
